import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import LoadingFace from 'components/ui/AnimatedStates/LoadingFace';

const Loading = () => {
  return (
    <LoadingFace
      headerText={getTranslatedString('maintenanceVendors.loading.title')}
      bodyText={getTranslatedString('maintenanceVendors.loading.body')}
    />
  );
};

export default Loading;
